import { createFileRoute, redirect } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";
import { McpSettingsPage } from "src/pages/McpSettingsPage";
import { mcpConnectionsQueryOptions } from "src/queries/mcp";

export const Route = createFileRoute("/_auth/settings/mcp")({
  component: McpSettingsPage,
  ssr: true,
  loader: async ({ context }) => {
    return loaderHandler(async (ctx) => {
      if (!ctx.session?.coach) {
        throw redirect({ to: "/settings" });
      }

      await context.queryClient.query({
        ...mcpConnectionsQueryOptions(),
        staleTime: "static",
      });
      return { data: null };
    });
  },
  staticData: {
    getBreadcrumb(ctx) {
      return {
        href: "/settings/mcp",
        label: ctx.i18n.t("settingsNavigation.mcp"),
      };
    },
  },
});
